import { isElementNode, isTextNode } from 'anodum';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import isBreakElement from '../verifiers/is-break-element';
import findFirstTextNode from './find-first-text-node';
import { BREAK_TAG } from '../constants/editable-elements';

const setCaretAtTheBeginningOfNode = (node) => {
  let targetNode = node;

  if (!isTextNode(node) && !isBreakElement(node)) {
    const firstTextNode = findFirstTextNode(node);
    targetNode = firstTextNode || node.querySelector(BREAK_TAG);
  }

  let index = 0;
  // In firefox we should set selection on parentNode instead of `br`. `br` doesn't allow to edit
  // element(but caret is set correctly).
  if (isElementNode(targetNode)) {
    const parent = targetNode.parentNode;
    index = [...parent.childNodes].indexOf(targetNode);

    targetNode = parent;
  }

  const selection = getAdvancedSelection();
  const { ownerDocument: liveDocument } = node;
  const range = liveDocument.createRange();
  range.setStart(targetNode, index);
  range.setEnd(targetNode, index);
  selection.removeAllRanges();
  selection.addRange(range);
  selection.refresh();
};

export default setCaretAtTheBeginningOfNode;
